/*
 * 功能模块的颜色变量配置
 */

import { ThemeColors } from '..';

export const lipSyncColors: ThemeColors = {
  color: {
    'script-limit-text': 'var(--script-limit-text)',
    'avatar-creating-color': 'var(--avatar-creating-color)',
  },
  backgroundColor: {
    'script-bg-primary': 'var(--script-bg-primary)',
    'script-voice-bg-primary': 'var(--script-voice-bg-primary)',
    'script-voice-select-btn-bg': 'var(--script-voice-select-btn-bg)',
    'script-voice-item-tag': 'var(--script-voice-item-tag)',
    'script-btn-bg': 'var(--script-btn-bg)',
    'script-add-btn-bg': 'var(--script-add-btn-bg)',
    'script-menu-bg': 'var(--script-menu-bg)',
    'avatar-bg': 'var(--avatar-bg)',
    'voice-modal-header-bg': 'var(--voice-modal-header-bg)',
    'voice-modal-body-bg': 'var(--voice-modal-body-bg)',
    'caption-panel-item-bg': 'var(--caption-panel-item-bg)',
    'caption-panel-fontstyle-bg': 'var(--caption-panel-fontstyle-bg)',
    'script-add-table': 'var(--script-add-table)',
    'more-icon-bg': 'var(--more-icon-bg)',
    'right-menu-active-bg': 'var(--right-menu-active-bg)',
    'panel-bg': 'var(--panel-bg)',
  },
  borderColor: {
    'voice-select-border': 'var(--voice-select-border)',
    'caption-panel-border': 'var(--caption-panel-border)',
    'caption-panel-picker-border': 'var(--caption-panel-picker-border)',
  },
};
